class Container {
    constructor({
                    alertTime,
                    alertTimeRemove
                }) {

        this.element = document.getElementById('alert-container');

        this.options = {
            alertTime,
            alertTimeRemove
        };

        if (!this.element)
            throw Error('No alert container element found!');
    }

    addAlert(alertElement) {
        this.element.classList.add('new-alert');

        this.element.appendChild(alertElement.element);
        const height = alertElement.element.offsetHeight;

        this.element.style.transform = `translateY(${height}px)`;


        setTimeout( () => {
            this.element.classList.remove('new-alert');
            this.element.style.transform = 'translateY(0)'
        }, 800);


        alertElement.hide(this.options.alertTime);
        alertElement.remove(this.options.alertTime + this.options.alertTimeRemove);
    }
}

module.exports = Container;
